import { PlusOutlined } from "@ant-design/icons";
import { message } from "antd";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CreateProjectMain from "./CreateProjectMain";
import { roleBasedAccessControlConstants } from "../../constants";
import { commonHelpers, rabcHelpers } from "../../helpers";

const CreateProject = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { projectDetails, loading, error } = useSelector(
    (state) => state.data360LiveProjectReducer || {}
  );

  const reducerList = useSelector((state) => state);

  let roleOfUser = commonHelpers.getRoleOfUserFromReduxState(
    reducerList?.auth?.userDetails
  );

  let doesHavePermission = rabcHelpers.hasUserHasRole({
    roleName: roleOfUser,
    scope: roleBasedAccessControlConstants.scopes.project.create,
  });

  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Handle API errors
  useEffect(() => {
    if (error) {
      message.error(error || "Failed to fetch project details");
    }
  }, [error]);

  return (
    <>
      {doesHavePermission && (
        <div
          // onClick={showModal}
          className="project-details-wrapper create-project"
          style={{ opacity: 0.5, cursor: 'not-allowed' }}
        >
          <PlusOutlined className="icon-28" style={{ color: '#999' }} />
        </div>
      )}
      <CreateProjectMain
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        isEditMode={false}
        initialData={projectDetails}
        isLoading={loading}
      />
    </>
  );
};

export default CreateProject;
